import addIcon from '~assets/ic_black_add.png';

export const ORDER_TAKER_TABS = {
  CREATE_ORDER: 'createOrder'
};

export const ORDER_TAKER_SIDEBAR_ITEMS = {
  CREATE_ORDER: {
    name: ORDER_TAKER_TABS.CREATE_ORDER,
    order: 1,
    icon: addIcon
  }
};

const orderTakerSidebarItems = Object.values(ORDER_TAKER_SIDEBAR_ITEMS);

export const sortedOrderTakerSidebarItems = [...orderTakerSidebarItems].sort(
  (itemA, itemB) => itemA.order - itemB.order
);
